import { Button, Divider, Flex, Icon, Text } from '@chakra-ui/react';
import { AiFillPlusCircle } from 'react-icons/ai';

import { MdAddToPhotos } from 'react-icons/md';

export function UploadFotosPedido() {
  return (
    <>
      <Flex flexDir="column" alignItems="center" bg="white" py={4} px={5} gap={3} minH="100vh">
        <Flex alignItems="center" gap={2}>
          <Text fontSize="20px" color="#414042" fontWeight="bold">
            Foto Editada
          </Text>
          <Icon as={MdAddToPhotos} />
        </Flex>

        <Text fontSize="15px" maxW="300px" textAlign="center">
          Fotos editadas e manipulados para uso em mídias sociais
        </Text>

        <Button leftIcon={<Icon as={AiFillPlusCircle} />} colorScheme="blackAlpha" color="white">
          Adicionar novo arquivo
        </Button>
        <Button leftIcon={<Icon as={AiFillPlusCircle} />} colorScheme="blackAlpha" color="white">
          Adicionar novo arquivo
        </Button>
        <Button leftIcon={<Icon as={AiFillPlusCircle} />} colorScheme="blackAlpha" color="white">
          Adicionar novo arquivo
        </Button>
        <Button leftIcon={<Icon as={AiFillPlusCircle} />} colorScheme="blackAlpha" color="white">
          Adicionar novo arquivo
        </Button>

        <Divider w="full" borderColor="#707070" my={4} />

        <Flex alignItems="center" gap={2}>
          <Text fontSize="20px" color="#414042" fontWeight="bold">
            Foto Original
          </Text>
          <Icon as={MdAddToPhotos} />
        </Flex>

        <Text fontSize="15px" maxW="300px" textAlign="center">
          Fotos ou vídeos sem edição
        </Text>

        <Button leftIcon={<Icon as={AiFillPlusCircle} />} colorScheme="blackAlpha" color="white">
          Adicionar novo arquivo
        </Button>
        <Button leftIcon={<Icon as={AiFillPlusCircle} />} colorScheme="blackAlpha" color="white">
          Adicionar novo arquivo
        </Button>
        <Button leftIcon={<Icon as={AiFillPlusCircle} />} colorScheme="blackAlpha" color="white">
          Adicionar novo arquivo
        </Button>
        <Button leftIcon={<Icon as={AiFillPlusCircle} />} colorScheme="blackAlpha" color="white">
          Adicionar novo arquivo
        </Button>

        <Button size="lg" bg="#80BC00" color="white" mt={4} w="full" isDisabled>
          Confirmar
        </Button>
      </Flex>
    </>
  );
}
